import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/react-hooks";
import { Card, Table, Space, Button, notification, Popconfirm, Tag } from "antd";
import { teacherGql } from "../../graphql/teacher";
import { AddTeacherDlg } from "./components/AddTeacherDlg";
import { ApolloError } from "apollo-boost";
import { EditUserDlg } from "../user/components/EditUserDlg";
import { Store } from "../../store/Store";
import { observer } from "mobx-react";
import { UserLink } from "../../components/UserLink/UserLink";
import { userEditStore } from "../../store/user/UserEditStore";

export const OrgTeachers = observer(() => {
  let { id } = useParams<any>();
  const store = Store.orgsStore.orgView;

  const [showAdd, setShowAdd] = useState(false);

  const [setTeacher] = useMutation(teacherGql.setTeacher);

  const edit = (id) => {
    userEditStore.edit(id);
  };
  const closeEdit = (refresh) => {
    if (refresh) store.loadTeachers();
    userEditStore.close();
  };

  const onSetTeacher = (teacherId, type, fundraiser = false) => {
    setTeacher({ variables: { input: { orgId: id, teacherId, type, fundraiser } } })
      .then(() => {
        if (type === "Del") {
          notification.success({ message: `Remove teacher role successed!` });
        } else {
          notification.success({ message: `Update teacher role successed!` });
        }
        store.loadTeachers();
      })
      .catch((err: ApolloError) => {});
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Salutation",
      key: "title",
      dataIndex: ["teacher", "title"],
    },
    {
      title: "Teacher Name",
      dataIndex: ["teacher", "name"],
      key: "name",
      render: (_, r) => <UserLink userId={r.teacherId} name={r.teacher.name} />,
    },
    {
      title: "Email",
      dataIndex: ["teacher", "email"],
      key: "email",
    },
    {
      title: "Fundraiser",
      dataIndex: "fundraiser",
      key: "fundraiser",
      render: (v) => v && <Tag>Fundraiser</Tag>,
    },
    {
      title: "",
      dataIndex: "",
      key: "opt",
      render: (_, r) =>
        Store.isDivision ? null : (
          <Space>
            <Button size="small" key="edit" onClick={() => edit(r.teacherId)}>
              Edit
            </Button>

            <Popconfirm
              placement="top"
              title="Are you sure?"
              onConfirm={() => onSetTeacher(r.teacherId, "Del")}
              okText="Yes"
              cancelText="No"
            >
              <Button danger={true} size="small">
                Remove Teacher Role
              </Button>
            </Popconfirm>
            {store.org?.canFund && (
              <Popconfirm
                placement="top"
                title="Are you sure?"
                onConfirm={() => onSetTeacher(r.teacherId, "Update", !r.fundraiser)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger={true} size="small">
                  {r.fundraiser ? "Remove" : "Add"} Fundraiser Role
                </Button>
              </Popconfirm>
            )}
          </Space>
        ),
    },
  ];
  const onClose = () => {
    setShowAdd(false);
    store.loadTeachers();
  };
  return (
    <Card
      size="small"
      bodyStyle={{ padding: 0 }}
      extra={
        <Space>
          <Button size="small" loading={store.loadingTeachers} onClick={() => store.loadTeachers()}>
            Refresh
          </Button>

          {Store.isDivision ? null : (
            <Button size="small" onClick={() => setShowAdd(true)}>
              Add Teacher
            </Button>
          )}
        </Space>
      }
    >
      <Table
        size="small"
        loading={store.loadingTeachers}
        rowKey="childId"
        columns={columns}
        dataSource={store.org?.teachers}
      />
      {showAdd && <AddTeacherDlg orgId={id} onClose={() => onClose()} />}
      {userEditStore.visible && <EditUserDlg onClose={closeEdit} />}
    </Card>
  );
});
